import { render, staticRenderFns } from "./CallPriceSetting.vue?vue&type=template&id=6806bfa2"
import script from "./CallPriceSetting.vue?vue&type=script&lang=js"
export * from "./CallPriceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports